import angular from 'angular'
import inputTaxType from './inputTaxType'
import expenseConfig from './expenseConfig'
import deductionConfig from './deductionConfig'

export default angular
    .module('input.basedata', [inputTaxType, expenseConfig, deductionConfig])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('input.basedata', {
            abstract: true,
            url: '/basedata',
            template: '<div ui-view></div>',
        })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/input/basedata/index.js